// extracted by mini-css-extract-plugin
export default {"wordBank":"style__wordBank___j6Oe6","used":"style__used___u03fi"};